export default __webpack_public_path__ + "static/spa-association-4bd5802e795f1d0ce7370d969d02eab1.svg";